import { CameraSource } from "@capacitor/camera";
import React from "react";
import { getDevicePhotoForDocument } from "../../../../get_device_photo";
import { STRINGS } from "../../../../strings";
import { translate } from "../../../../translate";
import { CAMERA_SVG, MOBILE_SVG } from "../../../../utils/svgs";
import { AppBottomSheet } from "../../../Generic/AppBottomSheet";
import { AppBoxActionCard } from "../../../Generic/AppBoxActionCard";
import { AppBoxActionCards } from "../../../Generic/AppBoxActionCards";

interface Props {
  documentName: string;
  isUploadOptionsOpen: boolean;
  onUploadOptionsOpen: (isOpen: boolean) => void;
  onOpenPassportScanner: () => void;
  onUploadFromDevice: (event: string) => void;
}

const PassportUploadActions = ({
  documentName,
  isUploadOptionsOpen,
  onUploadOptionsOpen,
  onOpenPassportScanner,
  onUploadFromDevice,
}: Props) => {
  const handleUploadFromDevice = React.useCallback(
    (dataUri: string) => {
      return onUploadFromDevice(dataUri);
    },
    [onUploadFromDevice]
  );

  const handleClickOpenFromGallery = React.useCallback(async () => {
    const photo = await getDevicePhotoForDocument({
      width: 1080,
      height: 1080,
      source: CameraSource.Photos,
    });

    if (photo !== null) {
      handleUploadFromDevice(photo);
    }
  }, [handleUploadFromDevice]);

  return (
    <div className="PassportUploadActions">
      <div
        className="PassportUploadActions_uploadDocumentButton"
        onClick={() => onUploadOptionsOpen(true)}
      >
        {documentName}
      </div>
      <AppBottomSheet
        isOpen={isUploadOptionsOpen}
        title={translate(STRINGS.HOW_WOULD_YOU_LIKE_TO_TO_UPLOAD_THE_FILE)}
        onRequestClose={() => onUploadOptionsOpen(false)}
      >
        <AppBoxActionCards>
          <AppBoxActionCard
            className="PassportUploadActions_uploadOptionCard"
            icon={CAMERA_SVG}
            label={translate(STRINGS.SCAN_A_PHOTO)}
            onClick={() => {
              onUploadOptionsOpen(false);
              onOpenPassportScanner();
            }}
          />
          <AppBoxActionCard
            className="PassportUploadActions_uploadOptionCard"
            icon={MOBILE_SVG}
            label={translate(STRINGS.UPLOAD_FROM_GALLERY)}
            onClick={() => {
              onUploadOptionsOpen(false);
              handleClickOpenFromGallery();
            }}
          />
        </AppBoxActionCards>
      </AppBottomSheet>
    </div>
  );
};

export default React.memo(PassportUploadActions);
